import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import React, { useCallback, useEffect, useMemo, useState, } from "react";
// import { getRequestWithAuth } from "Root/api/httpHelpers";
import { apiGetDiscountText, apiGetUserCart, apiGetCheckoutFlow, apiGetFlowExperience, apiGetPreferredPayment, apiGetStripeKeys, apiRemoveLineItem, apiAddAdditionalItemToNextOrder, } from "Root/api/apiCheckout";
import { apiGetBaseProfile } from "Root/api/apiQuiz";
import { withRouter, Route, Redirect, BrowserRouter, useLocation, } from "react-router-dom";
import toastService from "Root/profile/toastService";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import HowToLP from "Root/profile/components/HowToLP";
// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
import "Static/main.css";
import "animate.css/animate.min.css";
import GainfulLoading from "Components/GainfulLoading";
import { Checkout, CheckoutSummary, IngredientsPage, InfoPage, ReviewsPage, PersonalizationsPage, SegmentInfoPage, CartPage, ProteinInfoPage, FlavorsPage, AddonsPage, CheckoutVideosPage, WhatToDo, PasswordResetDone, } from "CheckoutComponents";
import posthog from "posthog-js";
import CheckoutConfirmNew from "./components/CheckoutConfirmNew";
import { updateUserCart } from "./redux/slices/checkoutUserCartSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCardData } from "./redux/slices/checkoutBillingSlice";
import { setBannerData as setBannerDataRedux, setIsInfuencer, setCheckoutSegment, } from "./redux/slices/checkoutComponentSlice";
import CheckoutResultsNew from "./components/CheckoutResultsNew";
import { setProfileUser } from "Root/profile/redux/actionCreators/makeActionCreator";
import * as api from "Root/api/apiCommon";
import DebugMenu from "Components/DebugMenu";
import { pageView } from "Helpers/helper";
export const CheckoutContext = React.createContext({});
function CheckoutRoutes() {
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.components);
    const empty_cart = {
        protein: 0,
        hydration: 0,
        preworkout: 0,
        creatine: 0,
        collagen: 0,
        fiber: 0,
        blenderbottle: 0,
        wb221: 0,
        wb222: 0,
        greens: 0,
    };
    const [updatingItems, setUpdatingItems] = useState([]);
    const [cart, setCartState] = useState(empty_cart);
    const setCart = useCallback((newCart) => {
        setCartState(newCart);
    }, [setCartState]);
    const [stripePromise, setStripePromise] = useState(null);
    const [userCart, setUserCart] = useState([]);
    const [updatingUserCart, setUpdatingUserCart] = useState(false);
    const [discountText, setDiscountText] = useState(null);
    const [discountBanner, setDiscountBanner] = useState(null);
    const [bannerData, setBannerData] = useState({ copy: "", code: "" });
    const [promoErrorText, setPromoErrorText] = useState();
    const [updatingFlavors, setUpdatingFlavors] = useState(false);
    const [updatingPrice, setUpdatingPrice] = useState(false);
    const [name, setName] = useState("");
    const [userData, setUserData] = useState({});
    const hideReviews = true;
    const [currentFirstPage, setCurrentFirstPage] = useState("");
    const [checkoutPages, setCheckoutPages] = useState([]);
    const [checkoutExperience, setCheckoutExperience] = useState("");
    function setFrontendCart(cartData) {
        const localCartCopy = { ...empty_cart };
        cartData.forEach((item) => {
            localCartCopy[item.item_type] = item.quantity || 0;
        });
        setCart(localCartCopy);
    }
    const fetchDiscountText = async () => {
        const { discount_text, discount_banner } = await apiGetDiscountText();
        setDiscountText(discount_text);
        setDiscountBanner(discount_banner);
        if (discount_banner === null) {
            getBannerCopy();
        }
    };
    const fetchUserCart = async () => {
        const data = await apiGetUserCart();
        if (data) {
            setUserCart(data);
            setFrontendCart(data);
            dispatch(updateUserCart(data));
        }
    };
    const fetchCheckoutPages = async () => {
        const data = await apiGetCheckoutFlow();
        if (data?.flow) {
            setCheckoutPages(data.flow);
        }
    };
    const fetchExperience = async () => {
        const data = await apiGetFlowExperience();
        if (data) {
            setCheckoutExperience(data);
            dispatch(setCheckoutSegment(data));
            dispatch(setIsInfuencer(data === "influencer"));
        }
    };
    const fetchPreferredPayment = async () => {
        const data = await apiGetPreferredPayment();
        if (data) {
            dispatch(setCardData({
                brand: "",
                isPaypal: data === "paypal",
            }));
        }
    };
    async function loadCartAndDiscount() {
        await fetchDiscountText();
        await fetchUserCart();
    }
    const getBannerCopy = async () => {
        const promo_banner = await api.getPromotionalBanner();
        const data = { copy: promo_banner.copy, code: promo_banner.code };
        setBannerData(data);
        dispatch(setBannerDataRedux(data));
    };
    const fetchCheckoutData = async () => {
        loadCartAndDiscount();
        fetchPreferredPayment();
        fetchCheckoutPages();
        fetchExperience();
        try {
            const data = await apiGetStripeKeys();
            setStripePromise(loadStripe(data.publicKey));
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
        }
        const promo_error_text = localStorage.getItem("promo_error_text");
        if (promo_error_text !== null) {
            setPromoErrorText(promo_error_text);
            toastService.errorMessage(promo_error_text);
            localStorage.removeItem("promo_error_text");
        }
        const { user_id, name, email, gender } = await apiGetBaseProfile();
        setUserData({ profileID: user_id, email: email });
        dispatch(setProfileUser({
            name,
            gender,
            email: email,
            has_subscription: false,
            summary_text: "",
            is_influencer: false,
            cancelled_less_two_days: false,
            gainful_member_since: 0,
            rd_check_in_completed: false,
            banner_data: {
                copy: "",
                code: "",
            },
            profile_id: "",
            full_name: "",
            showFutureOrderToggles: false,
            showPopup: false,
        }));
    };
    useEffect(() => {
        fetchCheckoutData();
    }, []); // Only run once
    useEffect(() => {
        if (checkoutPages[0] === "/checkout/your-protein/") {
            setCheckoutExperience("protein_only");
        }
    }, [checkoutPages, checkoutExperience]);
    useEffect(() => {
        if (Object.keys(userData).length > 0) {
            posthog?.identify(userData.profileID, {
                email: userData.email,
                gender: userData.gender,
            });
        }
    }, [userData]);
    function error_message(msg) {
        toastService.errorMessage(msg);
    }
    function updateCart(item, value) {
        const cart_copy = { ...cart };
        cart_copy[item] = value;
        setCart(cart_copy);
        setUpdatingUserCart(false);
        const newItems = [...updatingItems].filter((itemName) => itemName !== item);
        setUpdatingItems(newItems);
    }
    async function addItemToCart(item, callb) {
        const newItems = [...updatingItems];
        newItems.push(item);
        setUpdatingItems(newItems);
        setUpdatingUserCart(true);
        const data = { item };
        try {
            const resp = await apiAddAdditionalItemToNextOrder(data);
            setUserCart(resp.userCart);
            dispatch(updateUserCart(resp.userCart));
            toastService.successMessage(`Added ${resp.item_name} to cart.`);
            setUpdatingUserCart(false);
            setUpdatingItems([
                ...updatingItems.filter((itemName) => itemName !== item),
            ]);
            callb && callb();
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
            updateCart(item, 0);
            callb && callb();
        }
    }
    async function removeItemFromCart(item) {
        setUpdatingUserCart(true);
        const data = { item_key: item };
        try {
            const resp = await apiRemoveLineItem(data);
            setUserCart(resp.userCart);
            dispatch(updateUserCart(resp.userCart));
            toastService.successMessage(`Removed ${resp.item_name} from cart.`);
            updateCart(item, 0);
        }
        catch (e) {
            updateCart(item, 1);
        }
    }
    const setUserName = (userName) => {
        setName(userName);
    };
    let location = useLocation();
    useEffect(() => {
        pageView(location.pathname);
    }, [location.pathname]);
    const contextObject = useMemo(() => ({
        cart,
        setCart,
        fetchUserCart,
        userCart,
        setUserCart,
        updatingUserCart,
        setUpdatingUserCart,
        addItemToCart,
        removeItemFromCart,
        error_message,
        updatingItems,
        discountText,
        discountBanner,
        updatingFlavors,
        setUpdatingFlavors,
        setUserName,
        name,
        currentFirstPage,
        updatingPrice,
        setUpdatingPrice,
        checkoutExperience,
        checkoutPages,
        setCheckoutPages,
        promoErrorText,
        bannerData,
    }), [
        cart,
        setCart,
        fetchUserCart,
        userCart,
        setUserCart,
        updatingUserCart,
        setUpdatingUserCart,
        addItemToCart,
        removeItemFromCart,
        error_message,
        updatingItems,
        discountText,
        discountBanner,
        updatingFlavors,
        setUpdatingFlavors,
        setUserName,
        name,
        currentFirstPage,
        updatingPrice,
        setUpdatingPrice,
        checkoutExperience,
        checkoutPages,
        setCheckoutPages,
        promoErrorText,
        bannerData,
    ]);
    return (_jsxs("div", { children: [updatingUserCart && _jsx(GainfulLoading, {}), _jsxs(CheckoutContext.Provider, { value: contextObject, children: [stripePromise !== null && (_jsx(Elements, { stripe: stripePromise, children: _jsxs(BrowserRouter, { children: [_jsx(Route, { path: "/checkout/rdvideo/", component: CheckoutVideosPage }), _jsx(Route, { path: "/checkout/personalizations/", component: PersonalizationsPage }), _jsx(Route, { path: "/checkout/summary/", component: CheckoutSummary }), _jsx(Route, { path: "/checkout/cart/", component: Checkout }), _jsx(Route, { path: "/checkout/new-pdp/", component: CartPage }), _jsx(Route, { path: "/checkout/your-ingredients/", component: IngredientsPage }), _jsx(Route, { path: "/checkout/your-blend/", component: InfoPage }), _jsx(Route, { path: "/checkout/your-results/", component: SegmentInfoPage }), _jsx(Route, { path: "/checkout/reviews/", component: ReviewsPage }), _jsx(Route, { path: "/checkout/howtolp/", component: HowToLP }), _jsx(Route, { path: "/checkout/confirm-new/", component: CheckoutConfirmNew }), _jsx(Route, { path: "/checkout/results-new/", component: CheckoutResultsNew }), _jsx(Route, { path: "/checkout/what-to-do/", component: WhatToDo }), _jsx(Route, { path: "/checkout/password-reset-done/", component: PasswordResetDone }), _jsx(Route, { path: "/checkout/your-protein/", component: ProteinInfoPage }), _jsx(Route, { path: "/checkout/protein-flavors/", component: FlavorsPage }), _jsx(Route, { path: "/checkout/addons/", component: AddonsPage }), _jsx(Route, { exact: true, path: "/checkout/", children: checkoutPages && checkoutPages.length > 0 && (_jsx(Redirect, { to: {
                                            pathname: !hideReviews
                                                ? "/checkout/reviews/"
                                                : checkoutPages[0],
                                            search: `${location.search}`,
                                        } })) }), _jsx(Route, { path: "/checkout/confirm/", children: _jsx(Redirect, { to: "/checkout/confirm-new/" }) }), loading && _jsx(GainfulLoading, {})] }) })), _jsx(DebugMenu, {})] })] }));
}
export default withRouter(CheckoutRoutes);
